import React, { useState } from "react";
import css from "./DashboardMobileScreen.module.css";
import MobileBottomTab from "../../../../stories/MobileBottomTab/MobileBottomTab";
import ProfileMobile from "../../../../components/CoachFlow/CoachDashboard/Profile/ProfileMobile";
import TodoMobile from "../../../../components/CoachFlow/CoachDashboard/Todo/TodoMobile/TodoMobile";
import {
  bookingIconGray,
  HomeIconGray,
  messageIconGray,
  NotificationIconGray,
  ProfileIconGray,
} from "../../../../constant/imagePath";
import { useHistory, useLocation } from "react-router-dom";

function DashboardMobileScreen() {
  const history = useHistory();
  const location = useLocation();
  const [menuItem, setMenuItem] = useState(location?.pathname?.split("/")[1]);
  const [isData, setIsData] = useState(false);


  return (
    <div className={css.mobileHeader}>
      {menuItem == "todo" && <TodoMobile setIsData={setIsData} />}
      {menuItem == "profile" && <ProfileMobile setIsData={setIsData} />}

      <div className={css.BottomTab}>
        <MobileBottomTab state={menuItem}
        />
      </div>
    </div>
  );
}

export default DashboardMobileScreen;
